var publicPath = __webpack_public_path__;
                    var symbolUrl = 'sprites.d7297429b712f0db2eb964354e7b2856.svg#bf';
                    var viewUrl = 'sprites.d7297429b712f0db2eb964354e7b2856.svg#view-bf';

                    

                    module.exports = {
                        url: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 90 11',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };